module.exports = __webpack_public_path__ + "img/Garborg_Arne_og_Hulda.bdbef2ee.jpg";